const queues = {
  title: "Kø",
  id: "ID",
  queue: "Oppgavekø",
  payload: "Oppgave",
  attempts: "Forsøk",
  reserved_at: "Reservert",
  available_at: "Tilgjengelig",
  created_at: "Opprettet",
}
export default queues
